export { default } from '@telexpress_auth/vue-arp';
